// eslint-disable-next-line import/prefer-default-export
export const SD_STATUS = {
    NEW: 'New',
    USED: 'Used',
    CPO: 'CPO',
    MIXED: 'Mixed',
};
